import { FC } from 'react';
import Tooltip from '../Tooltip';
import { IconContainer, Root, Circle } from './styled';

type Props = {
  status: string;
  size: string;
  text: string;
};

const IconCircle: FC<Props> = ({ status, size, text }) => {
  return (
    <Root>
      <Tooltip paragraph={text}>
        <IconContainer>
          <Circle $status={status} size={size} />
        </IconContainer>
      </Tooltip>
    </Root>
  );
};

export default IconCircle;
